import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import authService from '../api-authorization/AuthorizeService';
import CircularProgress from '@mui/material/CircularProgress';
import { SelectValidator } from 'react-material-ui-form-validator';

interface IDropdownProps {
    id: number;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

class DropdownViewModel {
    id: number = 0;
    value: string = '';
}

export default function NoteTypeDropdown(props: IDropdownProps) {
    const [list, setList] = React.useState<DropdownViewModel[]>([]);
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        setLoaded(false);
        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();

        const response = await fetch('Account/GetNoteTypes', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setList(data.value);
        setLoaded(true);
    }

    const items = list.map((item, index) =>
        <MenuItem key={index} value={item.id}>{item.value}</MenuItem>);

    return (
        <SelectValidator
            label="Note Types"
            name="noteTypeId"
            variant="outlined"
            margin="normal"
            fullWidth
            validators={['required']}
            errorMessages={['This field is required']}
            onChange={props.onChange}
            value={items.length <= 0 || props.id === 0 ? '' : props.id}
            InputProps={{
                disabled: !loaded,
                startAdornment: (
                    <React.Fragment>
                        {loaded ? null : <CircularProgress size={20} />}
                    </React.Fragment>
                )
            }}
        >
            {items}
        </SelectValidator>
    );
}